import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { ClipboardLogo } from "@src/appV2/lib";
import { useDoubleTap } from "@src/appV2/lib/utils";
import { type ReactElement } from "react";

const tagLines = ["Hundreds of shifts.", "Instant payouts.", "Great pay."];

interface AuthHeadlineProps {
  onLogoSecretTap?: () => void;
}

export function AuthHeadline(props?: AuthHeadlineProps): ReactElement {
  const onLogoSecretTap = props?.onLogoSecretTap;
  const handleLogoTap = useDoubleTap(onLogoSecretTap);

  return (
    <Stack
      spacing={2}
      alignItems="center"
      textAlign="center"
      sx={{
        paddingTop: 4,
      }}
    >
      <Stack
        sx={{
          cursor: onLogoSecretTap ? "pointer" : "default",
        }}
        onTouchEnd={handleLogoTap}
        onClick={handleLogoTap}
      >
        <ClipboardLogo width={200} />
      </Stack>
      <Stack spacing={3}>
        {tagLines.map((tagLine) => (
          <Text
            key={tagLine}
            variant="h3"
            sx={{
              color: (theme) => theme.palette.primary.light,
            }}
          >
            {tagLine}
          </Text>
        ))}
      </Stack>
    </Stack>
  );
}
